import ReducerRegistry from '../base/redux/ReducerRegistry';
import { set } from '../base/redux/functions';
import { CAPTURE_SIGNATURE_EVENTS, SIGNATURE_ACTIVE, SET_CONTROLLED_SIGNATURE_PARTICIPANT, SET_SIGNATURE_CONTROLLER, SET_RECEIVER_SIGNATURE_ENABLED, SET_RECEIVER_SIGNATURE_TRANSPORT, SET_REQUESTED_SIGNATURE_PARTICIPANT } from './actionTypes';
/**
 * The default state.
 */
const DEFAULT_STATE = {
    active: false,
    controller: {
        isCapturingEvents: false
    },
    receiver: {
        enabled: false
    }
};
/**
 * Listen for actions that mutate the signature state.
 */
ReducerRegistry.register('features/signature', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CAPTURE_SIGNATURE_EVENTS:
            return {
                ...state,
                controller: set(state.controller, 'isCapturingEvents', action.isCapturingEvents)
            };
        case SIGNATURE_ACTIVE:
            return set(state, 'active', action.active);
        case SET_RECEIVER_SIGNATURE_TRANSPORT:
            return {
                ...state,
                receiver: set(state.receiver, 'transport', action.transport)
            };
        case SET_RECEIVER_SIGNATURE_ENABLED:
            return {
                ...state,
                receiver: set(state.receiver, 'enabled', action.enabled)
            };
        case SET_REQUESTED_SIGNATURE_PARTICIPANT:
            return {
                ...state,
                controller: set(state.controller, 'requestedParticipant', action.requestedParticipant)
            };
        case SET_CONTROLLED_SIGNATURE_PARTICIPANT:
            return {
                ...state,
                controller: set(state.controller, 'controlled', action.controlled)
            };
        case SET_SIGNATURE_CONTROLLER:
            return {
                ...state,
                receiver: set(state.receiver, 'controller', action.controller)
            };
    }
    return state;
});
